(function () {
  "use strict";
  var Qe = ["USD", "AUD", "NZD", "KRW"],
    ta = { AU: "AUD", US: "USD", NZ: "NZD", KR: "KRW" },
    ea = { USD: "$", AUD: "$", NZD: "$", KRW: "\u20A9" },
    Ct = "pesado_cart_recommendations_v1",
    aa = 14400 * 1e3,
    ra = {},
    v = null,
    k = null,
    _e = null,
    P = 0,
    et = !1,
    we = null,
    D = null,
    at = null,
    Ht = 0,
    Se = !1,
    rt = !1,
    W = null,
    Z = 0,
    mt = 0,
    Dt = null,
    Ft = "",
    G = null,
    J = null,
    ft = 0,
    $t = {},
    na = window.PesadoThemeContext || {},
    F = na.recommendations || {};
  function Kt() {
    return window.PesadoUpgradeAnalytics || null;
  }
  function gt(t, e) {
    var a = Kt();
    return a && typeof a.track == "function" ? a.track(t, e || {}) : null;
  }
  function Ae(t, e) {
    var a = Kt(),
      r =
        a && typeof a.lineProperties == "function"
          ? a.lineProperties(t, e || {})
          : {};
    return (
      v &&
        v.modelId &&
        v.brandId &&
        v.snapshot &&
        Object.assign(r, {
          _pesado_compatibility_brand_id: v.brandId,
          _pesado_compatibility_model_id: v.modelId,
          _pesado_compatibility_machine: v.modelName,
          _pesado_compatibility_snapshot_version: v.snapshot.version,
          _pesado_compatibility_snapshot_checksum: v.snapshot.checksum,
          _pesado_compatibility_snapshot_theme_id: v.snapshot.targetThemeId,
        }),
      r
    );
  }
  function Wt() {
    var t = Kt();
    return t && typeof t.ensureCartAttribution == "function"
      ? t.ensureCartAttribution()
      : Promise.resolve();
  }
  function vt() {
    var t = document.querySelector("[data-currency-wrap] [data-current]");
    if (t && t.textContent) return t.textContent.trim().toUpperCase();
    if (window.Shopify && Shopify.currency && Shopify.currency.active)
      return Shopify.currency.active.toUpperCase();
    try {
      if (
        window.T4SThemeSP &&
        typeof T4SThemeSP.storageCurrency == "function"
      ) {
        var e = T4SThemeSP.storageCurrency();
        if (e) return String(e).toUpperCase();
      }
    } catch {}
    try {
      var a = localStorage.getItem("T4Currency");
      if (a) return a.toUpperCase();
    } catch {}
    return null;
  }
  function nt(t) {
    var e = String(t || "")
      .trim()
      .toUpperCase();
    return /^[A-Z]{2}$/.test(e) ? e : null;
  }
  function ia(t) {
    var e = document.getElementById("countryMirror"),
      a = nt(e && e.value);
    if (a) return a;
    var r = document.querySelector(
      "[data-currency-wrap] [data-currency-item].is--selected[data-country]",
    );
    return (
      (a = nt(r && r.getAttribute("data-country"))),
      a ||
      (window.Shopify &&
        ((a = nt(Shopify.country)),
        a ||
          ((a = nt(
            Shopify.localization &&
              Shopify.localization.country &&
              (Shopify.localization.country.iso_code ||
                Shopify.localization.country.isoCode),
          )),
          a)))
        ? a
        : nt(t && t.getAttribute("data-market-country"))
    );
  }
  function ke(t, e) {
    var a = ia(t),
      r = String(e || vt() || "")
        .trim()
        .toUpperCase(),
      i = String(
        (t && t.getAttribute("data-reward-countries")) || "AU,US,NZ,KR",
      )
        .split(",")
        .map(function (l) {
          return nt(l);
        })
        .filter(Boolean),
      n = a && ta[a],
      s = String((t && t.getAttribute("data-market-currency")) || "")
        .trim()
        .toUpperCase(),
      o = !!a && i.indexOf(a) !== -1,
      c = !!r && Qe.indexOf(r) !== -1 && !!n && r === n && (!s || s === n);
    return { eligible: !!t && o && c, country: a, currency: r };
  }
  function it(t, e) {
    var a = ea[e] || "";
    return e === "KRW"
      ? a + Math.round(t).toLocaleString("en-US")
      : a + t.toFixed(2) + " " + e;
  }
  function oa(t, e) {
    return t
      ? '<span class="t4s-mcsb__cup" style="left:' +
          Math.max(3, Math.min(97, e)).toFixed(2) +
          '%"><img src="' +
          t +
          '" alt="" aria-hidden="true"></span>'
      : "";
  }
  function Zt(t) {
    return t === "shipping"
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5h11v11H3zM14 9h3l3 3v4h-6zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"></path></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12 12 4h7v7l-8 8-7-7v-7Z"></path><circle cx="16" cy="8" r="1.15"></circle><path d="m9 15 6-6"></path></svg>';
  }
  function Gt(t) {
    var e = t.classList.contains("t4s-mcsb--page")
      ? t.closest("[data-cart-wrapper]")
      : document.getElementById("t4s-mini_cart");
    if (e) {
      var a = e.querySelector("[data-pesado-reward-total]");
      a && a.remove();
    }
  }
  function Jt(t, e) {
    var a = t.classList.contains("t4s-mcsb--page")
      ? t.closest("[data-cart-wrapper]")
      : document.getElementById("t4s-mini_cart");
    if (a) {
      var r = a.querySelector(".t4s-cart__tax");
      if (r) {
        r.hasAttribute("data-pesado-default-shipping-copy") ||
          r.setAttribute("data-pesado-default-shipping-copy", r.innerHTML);
        var i =
            r.getAttribute("data-copy-locked") ||
            r.getAttribute("data-pesado-default-shipping-copy"),
          n = a.querySelector("[data-pesado-free-shipping-status]");
        if (e) {
          if (!n) {
            ((n = document.createElement("div")),
              (n.className = "pesado-free-shipping-status"),
              n.setAttribute("data-pesado-free-shipping-status", ""),
              (n.innerHTML =
                '<span aria-hidden="true">\u2713</span><strong></strong>'));
            var s = a.querySelector(".t4s-cart-total");
            s && s.parentNode
              ? s.parentNode.insertBefore(n, s)
              : r.parentNode.insertBefore(n, r);
          }
          n.querySelector("strong").textContent =
            t.getAttribute("data-msg-success") || "Free shipping unlocked!";
        } else n && n.remove();
        r.innerHTML = t.getAttribute("data-free-shipping-exclusive") === "true" && e ? r.getAttribute("data-copy-unlocked") || i : i;
      }
    }
  }
  function ca(t) {
    var e = vt(),
      a = ke(t, e);
    if (!a.eligible) {
      (t.classList.add("t4s-d-none"),
        t.removeAttribute("data-pesado-reward-stage"));
      var r = t.querySelector("[data-mcsb-rows]");
      (r && ((r.innerHTML = ""), r.removeAttribute("data-mcsb-render-key")),
        Jt(t, !1),
        Gt(t));
      return;
    }
    var i = t.getAttribute("data-base-currency"),
      n = parseFloat(t.getAttribute("data-cart-total-cents")) || 0,
      s = {};
    try {
      s = JSON.parse(t.getAttribute("data-thresholds"));
    } catch {}
    var o = s[e];
    if (!o) {
      (t.classList.add("t4s-d-none"),
        t.removeAttribute("data-pesado-reward-stage"),
        Jt(t, !1),
        Gt(t));
      return;
    }
    // Market prices are not FX estimates. Wait for Shopify's local cart.
    if (!i || i !== e) {
      t.classList.add("t4s-d-none");
      t.removeAttribute("data-pesado-reward-stage");
      Jt(t, !1);
      Gt(t);
      return;
    }
    var c = n / 100;
    var shippingMinimum = o + (t.getAttribute("data-free-shipping-exclusive") === "true" ? 0.01 : 0);
    t.classList.remove("t4s-d-none");
    var l = t.querySelector("[data-mcsb-rows]");
    if (l) {
      var d = parseFloat(t.getAttribute("data-discount-10-threshold")) || 200,
        u = parseFloat(t.getAttribute("data-discount-15-threshold")) || 300,
        b = t.getAttribute("data-cup-image") || "";
      e === "KRW" && ((d = d * 1e3), (u = u * 1e3));
      var y = Math.max(0, Math.min(100, (c / Math.max(1, o)) * 100)),
        x = Math.max(0, Math.min(100, ((c - o) / Math.max(1, d - o)) * 100)),
        p = Math.max(0, Math.min(100, ((c - d) / Math.max(1, u - d)) * 100)),
        f = c < shippingMinimum ? y / 3 : c < d ? 33.333 + x / 3 : 66.666 + p / 3,
        C =
          t.getAttribute("data-msg-remaining") ||
          "You are [amount] away from free shipping",
        _ = t.getAttribute("data-msg-success") || "Free shipping unlocked!",
        A = C.replace("[amount]", it(Math.max(0, shippingMinimum - c), e)),
        m = "",
        h = 0;
      (c >= u
        ? ((A = "15% discount unlocked"), (m = "15% unlocked"), (h = 3))
        : c >= d
          ? ((A =
              "Add " + it(Math.max(0, u - c), e) + " more to unlock 15% off"),
            (m = "10% off unlocked"),
            (h = 2))
          : c >= shippingMinimum &&
            ((A =
              "Add " + it(Math.max(0, d - c), e) + " more to unlock 10% off"),
            (m = _),
            (h = 1)),
        Jt(t, c >= shippingMinimum),
        Gt(t));
      var L = [a.country, e, Math.round(c * 100), o, d, u].join("|");
      if (l.getAttribute("data-mcsb-render-key") !== L) {
        var Y = parseInt(t.getAttribute("data-pesado-reward-stage"), 10),
          T = !isNaN(Y) && h > Y;
        (t.setAttribute("data-pesado-reward-stage", h),
          T &&
            gt("reward_unlocked", {
              reward_stage: h,
              reward_name:
                h === 1
                  ? "free_shipping"
                  : h === 2
                    ? "discount_10"
                    : "discount_15",
              cart_total: c,
            }));
        var R =
            '<span class="t4s-mcsb__tier-dot t4s-mcsb__tier-dot--start is--complete"></span><span class="t4s-mcsb__tier-dot t4s-mcsb__tier-dot--ship' +
            (c >= shippingMinimum ? " is--complete" : " is--next") +
            '"></span><span class="t4s-mcsb__tier-dot t4s-mcsb__tier-dot--ten' +
            (c >= d ? " is--complete" : c >= shippingMinimum ? " is--next" : "") +
            '"></span><span class="t4s-mcsb__tier-dot t4s-mcsb__tier-dot--fifteen' +
            (c >= u ? " is--complete" : c >= d ? " is--next" : "") +
            '"></span>',
          N =
            '<div class="t4s-mcsb__benefits"><span class="t4s-mcsb__benefit t4s-mcsb__benefit--ship' +
            (c >= shippingMinimum ? " is--complete" : "") +
            '"><i>' +
            Zt("shipping") +
            "</i><b>Free shipping</b><small>" +
            it(o, e) +
            '</small></span><span class="t4s-mcsb__benefit' +
            (c >= d ? " is--complete" : c >= shippingMinimum ? " is--current" : "") +
            '"><i>' +
            Zt("tag") +
            "</i><b>10% off</b><small>" +
            it(d, e) +
            '</small></span><span class="t4s-mcsb__benefit' +
            (c >= u ? " is--complete" : c >= d ? " is--current" : "") +
            '"><i>' +
            Zt("tag") +
            "</i><b>15% off</b><small>" +
            it(u, e) +
            "</small></span></div>";
        ((l.innerHTML =
          '<div class="t4s-mcsb__reward-card' +
          (T ? " is--celebrate" : "") +
          '"><div class="t4s-mcsb__reward-head"><span>Rewards progress</span>' +
          (m ? '<div class="t4s-mcsb__unlocked">' + m + "</div>" : "") +
          "<strong>" +
          A +
          '</strong></div><div class="t4s-mcsb__track">' +
          oa(b, f) +
          R +
          '<span class="t4s-mcsb__seg t4s-mcsb__seg--one' +
          (c >= shippingMinimum ? " is--complete" : " is--active") +
          '"><span style="width:' +
          y.toFixed(2) +
          '%"></span></span><span class="t4s-mcsb__seg t4s-mcsb__seg--two' +
          (c >= d ? " is--complete" : c >= shippingMinimum ? " is--active" : "") +
          '"><span style="width:' +
          x.toFixed(2) +
          '%"></span></span><span class="t4s-mcsb__seg t4s-mcsb__seg--three' +
          (c >= u ? " is--complete" : c >= d ? " is--active" : "") +
          '"><span style="width:' +
          p.toFixed(2) +
          '%"></span></span></div>' +
          N +
          "</div>"),
          l.setAttribute("data-mcsb-render-key", L));
      }
    }
  }
  function It() {
    document
      .querySelectorAll("[data-multi-currency-shipbar]")
      .forEach(function (t) {
        ca(t);
      });
  }
  function xe(t) {
    if (t && cartCurrencyMatches(t)) {
      (document
        .querySelectorAll("[data-cart-count], [data-pesado-cart-count]")
        .forEach(function (a) {
          a.textContent !== String(t.item_count) &&
            (a.textContent = t.item_count);
        }),
        document
          .querySelectorAll("[data-pesado-cart-item-label]")
          .forEach(function (a) {
            var r = t.item_count === 1 ? "item" : "items";
            a.textContent !== r && (a.textContent = r);
          }));
      var e;
      try {
        e =
          new Intl.NumberFormat(document.documentElement.lang || "en-AU", {
            style: "currency",
            currency: t.currency,
            currencyDisplay: "narrowSymbol",
          }).format(t.total_price / 100) +
          " " +
          t.currency;
      } catch {
        e = (t.total_price / 100).toFixed(2) + " " + t.currency;
      }
      (document
        .querySelectorAll("[data-pesado-cart-checkout-total]")
        .forEach(function (a) {
          a.textContent !== e && (a.textContent = e);
        }),
        Array.from(document.documentElement.classList).forEach(function (a) {
          /^t4s-cart-count-\d+$/.test(a) &&
            document.documentElement.classList.remove(a);
        }),
        document.documentElement.classList.add(
          "t4s-cart-count-" + t.item_count,
        ));
    }
  }
  function Mt() {
    if (Z) {
      O(50);
      return;
    }
    var t = document.querySelector("[data-cart-timer]");
    Ce()
      .then(function (e) {
        ((D = e),
          xe(e),
          document
            .querySelectorAll("[data-multi-currency-shipbar]")
            .forEach(function (a) {
              (a.setAttribute("data-cart-total-cents", e.total_price),
                a.setAttribute("data-base-currency", e.currency));
            }),
          It(),
          t && (t.setAttribute("data-cart-item-count", e.item_count), pe()),
          O(0));
      })
      .catch(function () {
        It();
      });
  }
  var currencySyncFetch = window.fetch.bind(window),
    currencySyncRetryAfter = 0,
    currencySyncFailedContext = "";
  function cartMarketContext() {
    return [ht(""), vt() || "", ia(document.querySelector("[data-market-country]")) || ""].join("|");
  }
  function cartCurrencyMatches(cart) {
    var expected = vt();
    return !!cart && !!expected && cart.currency === expected;
  }
  function cartContextError() {
    var error = new Error("Cart context changed during request");
    error.staleCart = !0;
    return error;
  }
  function cartCurrencyRequest(url, options) {
    var controller = new AbortController(),
      timer = setTimeout(function () { controller.abort(); }, 12000);
    // Internal repricing must not look like an add/remove to the drawer interceptor.
    return currencySyncFetch(url, Object.assign({
      credentials: "same-origin", cache: "no-store", signal: controller.signal,
    }, options || {})).then(function (response) {
      if (!response.ok) throw new Error("Unable to synchronize cart currency");
      return response.json();
    }).finally(function () { clearTimeout(timer); });
  }
  function Ce() {
    var t = Ht, context = cartMarketContext();
    if (at && at.revision === t && at.context === context) return at.promise;
    var e = { revision: t, context: context };
    function assertCurrent() {
      if (t !== Ht || context !== cartMarketContext()) throw cartContextError();
    }
    return (
      (e.promise = cartCurrencyRequest(ht("cart.js") + "?_pesado_cart=" + Date.now())
        .then(function (a) {
          assertCurrent();
          if (cartCurrencyMatches(a)) return a;
          if (!vt() || (currencySyncFailedContext === context && Date.now() < currencySyncRetryAfter))
            throw new Error("Cart currency is not synchronized");
          currencySyncFailedContext = context;
          currencySyncRetryAfter = Date.now() + 30000;
          var section = window.cartT4SectionID || "mini_cart";
          // Empty updates reprices in the current locale without editing quantities,
          // line properties, notes, attributes or existing discount codes.
          return cartCurrencyRequest(ht("cart/update.js"), {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ updates: {}, sections: ["cart_data", section], sections_url: location.pathname + location.search }),
          }).then(function (cart) {
            assertCurrent();
            if (!cartCurrencyMatches(cart)) throw new Error("Shopify did not confirm the expected currency");
            currencySyncRetryAfter = 0;
            if (cart.sections && cart.sections.cart_data && cart.sections[section] && window.T4SThemeSP && T4SThemeSP.Cart)
              T4SThemeSP.Cart.renderContents(cart.sections);
            else document.dispatchEvent(new CustomEvent("cart:refresh"));
            return cart;
          });
        })
        .then(function (a) {
          assertCurrent();
          return a;
        })
        .finally(function () {
          at === e && (at = null);
        })),
      (at = e),
      e.promise
    );
  }
  var Ie = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/,
    Me = !1;
  function sa() {
    if (!Me) {
      if (((Me = !0), window.fetch)) {
        var t = window.fetch;
        window.fetch = function (i, n) {
          var s = typeof i == "string" ? i : (i && i.url) || "",
            o = Ie.test(s),
            c = o && /\/cart\/add/.test(s);
          o && De(c);
          var l = t.apply(this, arguments);
          return (
            o &&
              l
                .then(function (d) {
                  (oe(c, !d || d.ok !== !1), setTimeout(Mt, 60));
                })
                .catch(function () {
                  oe(c, !1);
                }),
            l
          );
        };
      }
      if (window.XMLHttpRequest) {
        var e = window.XMLHttpRequest,
          a = e.prototype.open,
          r = e.prototype.send;
        ((e.prototype.open = function (i, n) {
          return (
            (this._t4sCartMutation = Ie.test(n || "")),
            (this._t4sCartAdd = /\/cart\/add/.test(n || "")),
            a.apply(this, arguments)
          );
        }),
          (e.prototype.send = function () {
            return (
              this._t4sCartMutation &&
                (De(this._t4sCartAdd),
                this.addEventListener("loadend", function () {
                  (oe(
                    this._t4sCartAdd,
                    this.status >= 200 && this.status < 300,
                  ),
                    setTimeout(Mt, 60));
                })),
              r.apply(this, arguments)
            );
          }));
      }
    }
  }
  var ot = !0,
    Tt = {};
  function ht(t) {
    var e = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return e.replace(/\/?$/, "/") + String(t || "").replace(/^\//, "");
  }
  function zt() {
    return /\/pages\/compatibility-guide\/?$/i.test(
      window.location.pathname || "",
    );
  }
  function w(t) {
    return String(t ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
  function bt(t) {
    return t ? (typeof t == "string" ? t : t.src || t.url || "") : "";
  }
  function Te(t) {
    if (!t) return null;
    var e = t.id || t.variantId || t.variant_id;
    return e
      ? {
          id: Number(e),
          title: t.title || t.public_title || "Default Title",
          publicTitle: t.public_title || t.title || "",
          sku: t.sku || "",
          price: Number(t.price || 0),
          image: bt(t.featured_image || t.image),
          available: t.available !== !1,
        }
      : null;
  }
  function Yt(t) {
    return String(t || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }
  function Le(t, e) {
    var a = Yt(e);
    return a
      ? t
          .map(function (r, i) {
            return { variant: r, index: i };
          })
          .sort(function (r, i) {
            var n =
                Yt(
                  [r.variant.title, r.variant.publicTitle, r.variant.sku].join(
                    " ",
                  ),
                ).indexOf(a) !== -1,
              s =
                Yt(
                  [i.variant.title, i.variant.publicTitle, i.variant.sku].join(
                    " ",
                  ),
                ).indexOf(a) !== -1;
            return Number(s) - Number(n) || r.index - i.index;
          })
          .map(function (r) {
            return r.variant;
          })
      : t;
  }
  function ct(t) {
    if (!t) return null;
    var e = t.live || t.product || t,
      a = t.recommendationId || t.recommendation_id || t.id || "",
      r =
        window.PesadoCompatibilityData &&
        window.PesadoCompatibilityData.products &&
        window.PesadoCompatibilityData.products[a],
      i =
        t.preferredVariantMatch ||
        t.preferred_variant_match ||
        (r && r.preferredVariantMatch) ||
        "",
      n =
        t.variantCompatibilityImages ||
        (r && r.variantCompatibilityImages) ||
        {},
      s = bt(t.compatibilityImageUrl || (r && r.compatibilityImageUrl)),
      o =
        t.imageAuthority === "manager" ||
        !!r ||
        !!s ||
        Object.keys(n).length > 0,
      c = Le((t.variants || e.variants || []).map(Te).filter(Boolean), i),
      l = (r && r.hiddenVariantIds) || [];
    c = c.filter(function (u) {
      return l.indexOf(String(u.id)) === -1;
    });
    var d = (t.allowedVariantIds || t.allowed_variant_ids || []).map(String);
    return (
      d.length
        ? (c = c.filter(function (u) {
            return d.indexOf(String(u.id)) !== -1;
          }))
        : t.exactSkus && t.exactSkus.length
          ? (c = c.filter(function (u) {
              return (
                t.exactSkus
                  .map(function (b) {
                    return String(b).trim().toUpperCase();
                  })
                  .indexOf(
                    String(u.sku || "")
                      .trim()
                      .toUpperCase(),
                  ) !== -1
              );
            }))
          : t.tokens &&
            t.tokens.length &&
            (c = c.filter(function (u) {
              var b = [u.title, u.publicTitle, u.sku].join(" ").toLowerCase();
              return t.tokens.every(function (y) {
                return b.indexOf(String(y).toLowerCase()) !== -1;
              });
            })),
      o &&
        (c = c.map(function (u) {
          return Object.assign({}, u, {
            image: bt(n[String(u.id)]) || s || "",
          });
        })),
      !c.length &&
        (t.variantId || t.variant_id) &&
        c.push(
          Te({
            id: t.variantId || t.variant_id,
            title: t.variantTitle || t.variant_title,
            price: t.price,
            image: t.image,
            available: t.available,
          }),
        ),
      {
        recommendationId: a,
        productId: Number(
          t.productId || t.product_id || e.product_id || e.id || 0,
        ),
        handle: t.handle || e.handle || "",
        title: t.name || t.title || e.title || "",
        shortTitle:
          t.shortTitle ||
          t.short_title ||
          t.displayTitle ||
          t.display_title ||
          "",
        image: o
          ? s
          : bt(
              t.image ||
                t.featured_image ||
                e.featured_image ||
                (e.images && e.images[0]),
            ),
        cutout: o ? s : bt(t.cutout || t.cutout_image || t.cutoutImage),
        imageAuthority: o ? "manager" : "",
        compatibilityImageUrl: s,
        variantCompatibilityImages: n,
        tokens: Array.isArray(t.tokens) ? t.tokens.slice(0) : [],
        exactSkus: Array.isArray(t.exactSkus) ? t.exactSkus.slice(0) : [],
        category: t.category || t.cat || (r && r.cat) || "",
        role: t.role || "compatible",
        defaultVariantId: String(
          t.defaultVariantId || t.default_variant_id || "",
        ),
        allowedVariantIds: (
          t.allowedVariantIds ||
          t.allowed_variant_ids ||
          []
        ).map(String),
        preferredVariantMatch: i,
        variants: c,
      }
    );
  }
  function Ee(t) {
    if (!t) return !1;
    if (String(t.category || "").toLowerCase() === "portafilter") return !0;
    var e = [t.recommendationId, t.handle, t.title].join(" ").toLowerCase();
    return /\bportafilters?\b|(^|[-_])pf(?:[-_]|$)/.test(e);
  }
  function da(t) {
    if (!t) return !1;
    var e = t.properties || {};
    return e._pesado_compatibility_workflow
      ? !0
      : /\bportafilters?\b|(^|[-_])pf(?:[-_]|$)/.test(
          [t.handle, t.product_title, t.title, t.product_type]
            .join(" ")
            .toLowerCase(),
        );
  }
  function Ne(t) {
    return !!(t && (t.items || []).some(da));
  }
  function ua(t) {
    return t && t.screenCompatibility === !1
      ? []
      : ((t && t.products) || []).filter(function (e) {
          return e && e.role === "kit";
        });
  }
  function Lt(t) {
    if (!t) return null;
    var e = t.context || t,
      a = window.PesadoCompatibilityData,
      r = a && a.publication,
      i = e.snapshot || {},
      n = !!(
        r &&
        String(i.targetThemeId || "") === String(r.targetThemeId || "") &&
        String(i.version || "") === String(r.version || "") &&
        String(i.checksum || "") === String(r.checksum || "")
      ),
      s =
        a &&
        (a.brands || []).find(function (_) {
          return String(_.id || _.slug || "") === String(e.brandId || "");
        }),
      o =
        s &&
        (s.models || []).find(function (_) {
          return String(_.id || "") === String(e.modelId || "");
        }),
      c = (o && o.familyId) || "",
      l = e.label || e.contextLabel || "Compatible with your selected setup",
      d = !!o,
      u = e.screenCompatibility !== !1,
      b = e.suppressRecommendations === !0,
      y = e.products || e.recommendations || [],
      x = {};
    if (!n || !o || !a || !a.products) return null;
    y.forEach(function (_) {
      var A = _ && (_.recommendationId || _.id);
      A && (x[A] = _);
    });
    var p = (o.products || []).slice();
    (a.universalRecommendations || []).forEach(function (_) {
      p.indexOf(_) === -1 && p.push(_);
    });
    var f = p
        .map(function (_) {
          var A = a.products[_],
            m = (o.assignments && o.assignments[_]) || {};
          return A
            ? ct(
                Object.assign({}, A, x[_] || {}, {
                  id: _,
                  recommendationId: _,
                  role: m.role || "compatible",
                  defaultVariantId:
                    m.defaultVariantId || A.preferredVariantId || "",
                  allowedVariantIds: m.allowedVariantIds || [],
                }),
              )
            : null;
        })
        .filter(Boolean),
      C = {
        label: l,
        sourceHandle: e.sourceHandle || e.source_handle || "",
        sourceVariant: e.sourceVariant || e.source_variant || "",
        sourceVariantId: String(e.sourceVariantId || ""),
        family: c,
        brandId: s.id || s.slug || "",
        modelId: o.id || "",
        modelName: o.name || e.modelName || "",
        machineSelection: d,
        screenCompatibility: u,
        machineProducts: f,
        products: f,
        snapshot: {
          version: r.version,
          checksum: r.checksum,
          targetThemeId: r.targetThemeId,
        },
        suppressRecommendations: b,
        createdAt: Date.now(),
      };
    return C;
  }
  function Xt(t) {
    try {
      t
        ? sessionStorage.setItem(Ct, JSON.stringify(t))
        : sessionStorage.removeItem(Ct);
    } catch {}
  }
  function Et() {
    try {
      var t = JSON.parse(sessionStorage.getItem(Ct) || "null");
      return (
        t &&
          ["products", "recommendations", "machineProducts"].forEach(
            function (e) {
              Array.isArray(t[e]) &&
                (t[e] = t[e].map(function (a) {
                  return a && Object.assign({}, a, { variants: [] });
                }));
            },
          ),
        !t || !t.createdAt || Date.now() - t.createdAt > aa
          ? (sessionStorage.removeItem(Ct), null)
          : Lt(t)
      );
    } catch {
      return null;
    }
  }
  function qe(t) {
    ((P += 1), (v = Lt(t)), Xt(v), Qt(v), O(0));
  }
  function Qt(t) {
    !t ||
      t.suppressRecommendations ||
      (t.products || []).forEach(function (e) {
        ee(e).catch(function () {});
      });
  }
  function Oe() {
    ((P += 1), (v = null), Xt(null), O(0));
  }
  function la(t) {
    var e = window.PesadoCompatibilityData;
    if (!t || !e || !e.publication || !e.products) return null;
    var fit = companionFitApi(), contexts = [];
    for (var a = t.items || [], r = 0; r < a.length; r += 1) {
      var i = a[r],
        n = i.properties || {},
        s = n._pesado_compatibility_model_id,
        o = n._pesado_compatibility_brand_id;
      if (fit && !fit.fitSensitive(i.variant_id || i.id)) continue;
      if (!(!s || !o)) {
        var c = Lt({
          label:
            "Compatible with " +
            (n._pesado_compatibility_machine ||
              i.product_title ||
              "your selected machine"),
          sourceHandle: i.handle,
          sourceVariant: i.variant_title || "",
          sourceVariantId: i.variant_id || i.id,
          brandId: o,
          modelId: s,
          modelName: n._pesado_compatibility_machine || "",
          machineSelection: !0,
          snapshot: {
            version: n._pesado_compatibility_snapshot_version,
            checksum: n._pesado_compatibility_snapshot_checksum,
            targetThemeId: n._pesado_compatibility_snapshot_theme_id,
          },
        });
        if (c && !fit) return c;
        if (c && validCompanionMachineContext(c, {items:[i]})) contexts.push(c);
      }
    }
    return contexts.length && contexts.every(function (context) { return context.brandId === contexts[0].brandId && context.modelId === contexts[0].modelId; }) ? contexts[0] : null;
  }
  function companionFitApi() { return window.PesadoCartFitWarning && typeof window.PesadoCartFitWarning.canRecommend === 'function' ? window.PesadoCartFitWarning : null; }
  function companionFitRequired() { return !!document.getElementById('pesado-cart-fit-config'); }
  function validCompanionMachineContext(context, cart) {
    var fit = companionFitApi();
    if (!fit || !context || !context.modelId) return false;
    if ((cart.items || []).some(function (item) {
      var properties = item.properties || {};
      return fit.fitSensitive(item.variant_id || item.id) && properties._pesado_compatibility_model_id &&
        (properties._pesado_compatibility_model_id !== context.modelId || properties._pesado_compatibility_brand_id !== context.brandId);
    })) return false;
    return (cart.items || []).some(function (item) {
      var id = String(item.variant_id || item.id);
      if (!fit.fitSensitive(id)) return false;
      var properties = item.properties || {};
      if (!context.sourceHandle && (properties._pesado_compatibility_model_id !== context.modelId || properties._pesado_compatibility_brand_id !== context.brandId)) return false;
      if (context.sourceHandle && (item.handle !== context.sourceHandle || context.sourceVariantId && id !== String(context.sourceVariantId))) return false;
      return (context.machineProducts || context.products || []).some(function (product) {
        return product.handle === item.handle && product.allowedVariantIds.length && product.allowedVariantIds.indexOf(id) !== -1;
      });
    });
  }
  function filterCompanionFitProducts(products, cart) {
    var fit = companionFitApi();
    return !fit ? products : products.filter(Boolean).map(function (product) {
      return Object.assign({}, product, {variants:product.variants.filter(function (variant) { return fit.canRecommend(cart, [{id:variant.id,quantity:1}]); })});
    }).filter(function (product) { return product.variants.some(function (variant) { return variant.available; }); });
  }
  function fitCheckedCompanionAdd(url, options) {
    if (!companionFitRequired()) return fetch(url, options);
    var fit = companionFitApi();
    if (!fit) return Promise.reject(new Error('Compatibility could not be checked. Please try again.'));
    return fit.assertAdd(JSON.parse(options.body).items).then(function () { return fetch(url, options); });
  }
  function pa(t, e) {
    return !t || !t.sourceHandle
      ? !0
      : (e.items || []).some(function (a) {
          return a.handle !== t.sourceHandle
            ? !1
            : t.sourceVariantId
              ? String(a.variant_id || a.id) === String(t.sourceVariantId)
              : t.sourceVariant
                ? String(a.variant_title || a.title || "")
                    .toLowerCase()
                    .indexOf(String(t.sourceVariant).toLowerCase()) !== -1
                : !0;
        });
  }
  function ma(t, e) {
    return !t || !t.products || !e
      ? !1
      : (e.items || []).some(function (a) {
          var r = [a.variant_title, a.title, a.sku].join(" ").toLowerCase();
          return t.products.some(function (i) {
            if (!i || !i.handle || i.handle !== a.handle) return !1;
            var n = i.tokens || [];
            return (
              !n.length ||
              n.every(function (s) {
                return r.indexOf(String(s).toLowerCase()) !== -1;
              })
            );
          });
        });
  }
  function te() {
    var t = window.PesadoCompatibilityData;
    if (!t || t.managerUnavailable || !t.publication || !t.products)
      return null;
    var e = (t.universalRecommendations || [])
      .map(function (a) {
        var r = t.products[a];
        return r
          ? ct(
              Object.assign({}, r, {
                recommendationId: a,
                defaultVariantId: r.preferredVariantId || "",
              }),
            )
          : null;
      })
      .filter(Boolean);
    return e.length
      ? {
          label: "Universal accessories",
          family: "",
          sourceHandle: "",
          products: e,
          machineProducts: [],
          machineSelection: !1,
          universalOnly: !0,
          screenCompatibility: !1,
          snapshot: t.publication,
        }
      : null;
  }
  function fa(t) {
    return t
      ? (Tt[t] ||
          (Tt[t] = fetch(ht("products/" + t + ".js"), {
            credentials: "same-origin",
          })
            .then(function (e) {
              if (!e.ok) throw new Error("Unable to load product");
              return e.json();
            })
            .catch(function () {
              return (delete Tt[t], null);
            })),
        Tt[t])
      : Promise.resolve(null);
  }
  function ee(t) {
    if (
      ((t = ct(t)),
      !t ||
        (!t.handle && t.variants.length) ||
        (t.productId && t.variants.length && t.title && t.image))
    )
      return Promise.resolve(t);
    var e = t.variants.map(function (a) {
      return Number(a.id);
    });
    return fa(t.handle).then(function (a) {
      if (!a) return t;
      var r = ct({
        recommendationId: t.recommendationId,
        productId: a.id,
        handle: a.handle,
        title: t.title || a.title,
        shortTitle: t.shortTitle,
        image: t.image || a.featured_image,
        cutout: t.cutout,
        imageAuthority: t.imageAuthority,
        compatibilityImageUrl: t.compatibilityImageUrl,
        variantCompatibilityImages: t.variantCompatibilityImages,
        tokens: t.tokens,
        exactSkus: t.exactSkus,
        category: t.category,
        role: t.role,
        defaultVariantId: t.defaultVariantId,
        allowedVariantIds: t.allowedVariantIds,
        preferredVariantMatch: t.preferredVariantMatch,
        variants: a.variants,
      });
      return (
        e.length
          ? (r.variants = r.variants.filter(function (i) {
              return e.indexOf(Number(i.id)) !== -1;
            }))
          : r.allowedVariantIds.length
            ? (r.variants = r.variants.filter(function (i) {
                return r.allowedVariantIds.indexOf(String(i.id)) !== -1;
              }))
            : r.exactSkus.length
              ? (r.variants = r.variants.filter(function (i) {
                  return (
                    r.exactSkus.indexOf(
                      String(i.sku || "")
                        .trim()
                        .toUpperCase(),
                    ) !== -1
                  );
                }))
              : r.tokens.length &&
                (r.variants = r.variants.filter(function (i) {
                  var n = [i.title, i.publicTitle, i.sku]
                    .join(" ")
                    .toLowerCase();
                  return r.tokens.every(function (s) {
                    return n.indexOf(String(s).toLowerCase()) !== -1;
                  });
                })),
        (r.variants = r.variants
          .map(function (i, n) {
            return { variant: i, index: n };
          })
          .sort(function (i, n) {
            var s =
                r.defaultVariantId &&
                String(i.variant.id) === r.defaultVariantId,
              o =
                r.defaultVariantId &&
                String(n.variant.id) === r.defaultVariantId;
            return Number(o) - Number(s) || i.index - n.index;
          })
          .map(function (i) {
            return i.variant;
          })),
        (r.variants = Le(r.variants, r.preferredVariantMatch)),
        r
      );
    });
  }
  function st(t, e) {
    var a =
      e ||
      vt() ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      "AUD";
    try {
      return (
        new Intl.NumberFormat(document.documentElement.lang || "en-AU", {
          style: "currency",
          currency: a,
          currencyDisplay: "narrowSymbol",
        }).format((Number(t) || 0) / 100) +
        " " +
        a
      );
    } catch {
      return ((Number(t) || 0) / 100).toFixed(2) + " " + a;
    }
  }
  function ae(t) {
    var e = document.querySelector(
        "#t4s-mini_cart [data-multi-currency-shipbar], [data-multi-currency-shipbar]",
      ),
      a = vt() || (t && t.currency) || "",
      r = ke(e, a),
      i = Number(
        (t &&
          (t.original_total_price ||
            t.items_subtotal_price ||
            t.total_price)) ||
          0,
      ),
      n = i / 100;
    if (!r.eligible || !cartCurrencyMatches(t))
      return {
        eligible: !1,
        country: r.country,
        currency: r.currency,
        subtotal: n,
        shipping: null,
        ten: null,
        fifteen: null,
        target: null,
        type: "disabled",
        gap: 0,
      };
    var s = 100,
      o = 200,
      c = 300;
    if (e) {
      try {
        var l = JSON.parse(e.getAttribute("data-thresholds") || "{}");
        s = Number(l[a] || s);
      } catch {}
      ((o = Number(e.getAttribute("data-discount-10-threshold") || o)),
        (c = Number(e.getAttribute("data-discount-15-threshold") || c)),
        a === "KRW" && ((o *= 1e3), (c *= 1e3)));
    }
    if (r.country === "US" && a === "USD") s = 130.01;
    var d = n < s ? s : n < o ? o : n < c ? c : null,
      u =
        d === s
          ? "free_shipping"
          : d === o
            ? "discount_10"
            : d === c
              ? "discount_15"
              : "complete";
    return {
      eligible: !0,
      country: r.country,
      currency: a,
      subtotal: n,
      shipping: s,
      ten: o,
      fifteen: c,
      target: d,
      type: u,
      gap: d == null ? 0 : Math.max(0, d - n),
    };
  }
  function ga(t, e) {
    if (!t || !e || t.handle !== e.handle) return !1;
    var a = t.tokens || [];
    if (!a.length) return !0;
    var r = [e.variant_title, e.title, e.sku].join(" ").toLowerCase();
    return a.every(function (i) {
      return r.indexOf(String(i).toLowerCase()) !== -1;
    });
  }
  function Ue(t, e, a) {
    var r = (t || []).filter(function (d) {
      return d && z(d);
    });
    if (r.length < 2) return null;
    var i = r.filter(function (d) {
        return !(e.items || []).some(function (u) {
          return ga(d, u);
        });
      }),
      n = r.reduce(function (d, u) {
        return d + Number(z(u).price || 0);
      }, 0),
      s = i.reduce(function (d, u) {
        return d + Number(z(u).price || 0);
      }, 0),
      o = Object.assign({}, e, {
        total_price: Number(e.total_price || 0) + s,
        items_subtotal_price:
          Number(e.items_subtotal_price || e.total_price || 0) + s,
        original_total_price:
          Number(
            e.original_total_price ||
              e.items_subtotal_price ||
              e.total_price ||
              0,
          ) + s,
      }),
      c = ae(o),
      l = c.eligible
        ? c.subtotal >= c.fifteen
          ? 15
          : c.subtotal >= c.ten
            ? 10
            : 0
        : 0;
    return {
      products: r,
      missing: i,
      kitTotal: n,
      missingTotal: s,
      reward: c,
      discount: l,
      afterReward: Math.round(n * (1 - l / 100)),
    };
  }
  function va(t) {
    var e = String((t && t.title) || ""),
      a = e.toLowerCase();
    return a.indexOf("stand") !== -1
      ? "stand"
      : a.indexOf("clump crusher") !== -1
        ? "Clump Crusher"
        : a.indexOf("shower screen") !== -1
          ? "HD screen"
          : a.indexOf("basket") !== -1
            ? a.indexOf("he basket") !== -1
              ? "HE basket"
              : "EP basket"
            : a.indexOf("portafilter") !== -1
              ? "portafilter"
              : a.indexOf("tamper") !== -1
                ? "tamper"
                : a.indexOf("distributor") !== -1
                  ? "distributor"
                  : a.indexOf("puck") !== -1
                    ? "puck screen"
                    : e;
  }
  function ha(t, e, a, r) {
    if (
      !zt() ||
      F.showCompleteKit === !1 ||
      (a && a.screenCompatibility === !1)
    )
      return "";
    if (!a.family) {
      var i =
        F.builderUrl || ht("pages/compatibility-guide?view=compatibility-v3");
      return (
        '<a class="pesado-cart-companion__kit pesado-cart-companion__kit--builder" href="' +
        w(i) +
        '"><span><small>Complete kit</small><strong>Build the right kit for your machine</strong></span><b>Find your machine&nbsp;\u2192</b></a>'
      );
    }
    var n = Ue(t, e, a);
    if (!n) return "";
    var s = n.missing
        .map(function (b) {
          return z(b).id;
        })
        .join(","),
      o = [];
    (n.reward.eligible &&
      n.reward.subtotal >= n.reward.shipping &&
      o.push(w(F.shippingCopy || "Free shipping unlocked")),
      n.discount === 15
        ? o.push(w(F.discount15Copy || "15% reward unlocked"))
        : n.discount === 10 && o.push("10% reward unlocked"));
    var c = Math.max(0, n.kitTotal - n.afterReward),
      l = [];
    (n.discount &&
      (l.push("<del>" + w(st(n.kitTotal, r)) + "</del>"),
      l.push("<strong>Save " + w(st(c, r)) + "</strong>")),
      o.length &&
        l.push(
          "<span>" +
            o
              .map(function (b) {
                return b.replace(" unlocked", "");
              })
              .join(" + ") +
            "</span>",
        ));
    var d = n.missing.length ? "Add complete kit" : "Complete kit added",
      u = w(st(n.discount ? n.afterReward : n.kitTotal, r));
    return (
      '<section class="pesado-cart-companion__kit pesado-cart-companion__kit--offer"><div class="pesado-cart-companion__kit-heading"><small>\u2605 ' +
      w(F.kitTitle || "Complete kit") +
      "</small><span>" +
      n.products.length +
      ' items</span></div><strong class="pesado-cart-companion__kit-title">' +
      w(a.label) +
      " essentials</strong><p>" +
      n.products
        .map(function (b) {
          return w(va(b));
        })
        .join(" + ") +
      '</p><div class="pesado-cart-companion__kit-offer">' +
      l.join("") +
      '</div><button type="button" data-pcc-add-kit data-variant-ids="' +
      s +
      '" ' +
      (n.missing.length ? "" : "disabled") +
      "><span>" +
      d +
      "</span>" +
      (n.missing.length
        ? '<b aria-hidden="true">\u2014</b><strong>' + u + "</strong>"
        : "") +
      '</button><span data-pcc-kit-status role="status" aria-live="polite"></span></section>'
    );
  }
  function z(t) {
    return (
      t.variants
        .filter(function (e) {
          return e.available;
        })
        .sort(function (e, a) {
          return Number(e.price || 0) - Number(a.price || 0);
        })[0] || null
    );
  }
  function Ve(t, e) {
    var a = (t && t.items) || [];
    if (Ne(t)) return "";
    var r = [e && e.sourceHandle, e && e.sourceVariant, e && e.label]
        .join(" ")
        .toLowerCase(),
      i =
        r.indexOf("high-diffusion-espresso-shower-screen-breville") !== -1 ||
        r.indexOf("br58hd") !== -1 ||
        r.indexOf("breville 58") !== -1,
      n = "";
    if (
      (a.forEach(function (o) {
        o.handle === "pesado-he-breville-54mm-high-extraction-basket"
          ? (n = "54")
          : !n &&
            i &&
            o.handle === "high-extraction-filter-basket" &&
            (n = "58");
      }),
      !n)
    )
      return "";
    var s = a.some(function (o) {
      return o.handle !== "hybrid-breville-54-58-portafilter"
        ? !1
        : String(o.variant_title || o.title || "")
            .toLowerCase()
            .indexOf("breville " + n) !== -1;
    });
    return s ? "" : n;
  }
  function ba(t, e) {
    return !e || !t || t.handle !== "hybrid-breville-54-58-portafilter"
      ? !1
      : t.variants.some(function (a) {
          return (
            String(a.title || a.publicTitle || a.sku || "")
              .toLowerCase()
              .indexOf("breville " + e) !== -1
          );
        });
  }
  function ya(t, e, a) {
    var r = ae(e),
      i = Ve(e, a),
      n = t.map(function (s, o) {
        var c = z(s);
        return {
          product: s,
          index: o,
          price: Number((c && c.price) || 0) / 100,
          compatibilityPriority: ba(s, i),
        };
      });
    return (
      (i || r.target != null) &&
        n.sort(function (s, o) {
          if (s.compatibilityPriority !== o.compatibilityPriority)
            return s.compatibilityPriority ? -1 : 1;
          if (r.target == null) return s.index - o.index;
          var c = s.price >= r.gap,
            l = o.price >= r.gap;
          return c !== l
            ? c
              ? -1
              : 1
            : c
              ? s.price - r.gap - (o.price - r.gap) || s.index - o.index
              : o.price - s.price || s.index - o.index;
        }),
      n.map(function (s, o) {
        var c =
          r.target == null
            ? "compatible"
            : s.price >= r.gap
              ? "unlocks_next_tier"
              : "closest_to_next_tier";
        return Object.assign({}, s.product, {
          pesadoRank: o + 1,
          pesadoReason: c,
          pesadoTargetTier: r.target,
          pesadoGapBefore: r.gap,
          pesadoRewardType: r.type,
          pesadoCompatibilityPriority: s.compatibilityPriority,
        });
      })
    );
  }
  function _a(t, e) {
    var a = Number(t.pesadoTargetTier || 0);
    if (
      !a ||
      t.pesadoReason === "compatible" ||
      t.pesadoRewardType === "disabled"
    )
      return "";
    var r = Number(t.pesadoGapBefore || 0),
      i = Number((z(t) && z(t).price) || 0) / 100;
    if (t.pesadoReason === "unlocks_next_tier") {
      if (t.pesadoRewardType === "free_shipping")
        return "Add this to unlock free shipping";
      if (t.pesadoRewardType === "discount_10")
        return "Add this to unlock 10% off";
      if (t.pesadoRewardType === "discount_15")
        return "Add this to unlock 15% off";
    }
    var n = Math.max(0, r - i);
    return "Get " + st(n * 100, e) + " closer to the next reward";
  }
  function Re() {
    (clearTimeout(Dt), (Dt = null), (ft += 1));
    var t = k && k.querySelector(".is--reward-nudge");
    if ((t && t.classList.remove("is--reward-nudge"), t)) {
      var e = t.querySelector("[data-pcc-nudge]");
      e && (e.hidden = !0);
    }
    (G && G.remove(), (G = null), J && J.remove(), (J = null), (Ft = ""));
  }
  function wa(t) {
    var e = t.target.closest(".pesado-cart-companion__cards");
    (t.stopPropagation(), e || t.preventDefault());
  }
  function Be(t) {
    try {
      var e = new window.URL(t, window.location.href);
      return (
        e.hostname === "cdn.shopify.com" && e.searchParams.set("width", "480"),
        e.href
      );
    } catch {
      return t;
    }
  }
  function Sa(t, e, a) {
    if (
      !t ||
      !e ||
      !a ||
      a.getAttribute("data-product-handle") !== "pesado-coffee-tamper-58mm-54mm"
    )
      return "";
    var r = e.textContent.trim();
    if (r.indexOf(" / White / ") === -1) return "";
    var i = r.replace(" / White / ", " / Black / "),
      n = Array.prototype.find.call(t.options, function (s) {
        return s.textContent.trim() === i;
      });
    return (n && n.getAttribute("data-image")) || "";
  }
  function re(t, e, a) {
    if (!t) return Promise.resolve("");
    var r = a && a.keepLargestComponent,
      i = a && a.cleanNeutralBackdrop,
      n =
        t +
        "|" +
        (e || "") +
        "|" +
        (r ? "largest" : "all") +
        "|" +
        (i ? "clean" : "standard");
    return (
      $t[n] ||
        ($t[n] = new Promise(function (s) {
          var o = new window.Image();
          ((o.crossOrigin = "anonymous"), (o.decoding = "async"));
          function c(l) {
            try {
              var d = function (g) {
                  var q = g * 4,
                    M = Math.floor(g / p),
                    K = g - M * p,
                    H = 0,
                    xt = [];
                  return (
                    K > 0 && xt.push(g - 1),
                    K + 1 < p && xt.push(g + 1),
                    M > 0 && xt.push(g - p),
                    M + 1 < f && xt.push(g + p),
                    xt.forEach(function (Ha) {
                      var ye = Ha * 4;
                      H = Math.max(
                        H,
                        Math.abs(h[q] - h[ye]),
                        Math.abs(h[q + 1] - h[ye + 1]),
                        Math.abs(h[q + 2] - h[ye + 2]),
                      );
                    }),
                    H
                  );
                },
                u = function (g) {
                  var q = g * 4;
                  if (h[q + 3] < 16) return !0;
                  var M = h[q],
                    K = h[q + 1],
                    H = h[q + 2];
                  return i
                    ? Math.min(M, K, H) >= 170 &&
                        Math.max(M, K, H) - Math.min(M, K, H) <= 20 &&
                        Math.max(
                          Math.abs(M - N[0]),
                          Math.abs(K - N[1]),
                          Math.abs(H - N[2]),
                        ) <= 90 &&
                        d(g) <= 14
                    : Math.min(M, K, H) >= 225 &&
                        Math.abs(M - N[0]) <= 18 &&
                        Math.abs(K - N[1]) <= 18 &&
                        Math.abs(H - N[2]) <= 18;
                },
                b = function (g) {
                  j[g] || !u(g) || ((j[g] = 1), (B[I] = g), (I += 1));
                },
                y = 480,
                x = Math.min(1, y / Math.max(o.naturalWidth, o.naturalHeight)),
                p = Math.max(1, Math.round(o.naturalWidth * x)),
                f = Math.max(1, Math.round(o.naturalHeight * x)),
                C = document.createElement("canvas");
              ((C.width = p), (C.height = f));
              var _ = C.getContext("2d", { willReadFrequently: !0 });
              _.drawImage(o, 0, 0, p, f);
              var A = _.getImageData(0, 0, p, f),
                m = A.data,
                h = m;
              if (l && l !== o) {
                var L = document.createElement("canvas");
                ((L.width = p), (L.height = f));
                var Y = L.getContext("2d", { willReadFrequently: !0 });
                (Y.drawImage(l, 0, 0, p, f),
                  (h = Y.getImageData(0, 0, p, f).data));
              }
              for (
                var T = p * f,
                  R = [0, p - 1, (f - 1) * p, T - 1],
                  N = R.reduce(
                    function (g, q) {
                      var M = q * 4;
                      return (
                        (g[0] += h[M]),
                        (g[1] += h[M + 1]),
                        (g[2] += h[M + 2]),
                        g
                      );
                    },
                    [0, 0, 0],
                  ).map(function (g) {
                    return g / R.length;
                  }),
                  dt = R.reduce(
                    function (g, q) {
                      var M = q * 4;
                      return (
                        (g[0] += m[M]),
                        (g[1] += m[M + 1]),
                        (g[2] += m[M + 2]),
                        g
                      );
                    },
                    [0, 0, 0],
                  ).map(function (g) {
                    return g / R.length;
                  }),
                  j = new Uint8Array(T),
                  B = new Int32Array(T),
                  S = 0,
                  I = 0,
                  U = 0,
                  X = 0;
                X < p;
                X += 1
              )
                (b(X), b((f - 1) * p + X));
              for (var Q = 1; Q < f - 1; Q += 1) (b(Q * p), b(Q * p + p - 1));
              for (; S < I;) {
                var E = B[S];
                ((S += 1), (m[E * 4 + 3] = 0), (U += 1));
                var _t = Math.floor(E / p),
                  Ze = E - _t * p;
                (Ze > 0 && b(E - 1),
                  Ze + 1 < p && b(E + 1),
                  _t > 0 && b(E - p),
                  _t + 1 < f && b(E + p));
              }
              if (U < T * 0.1 || U > T * 0.96) {
                s("");
                return;
              }
              if (i) {
                var ut = new Uint8Array(T);
                (ut.fill(255), (S = 0), (I = 0));
                for (var wt = 0; wt < T; wt += 1)
                  m[wt * 4 + 3] >= 16 || ((ut[wt] = 0), (B[I] = wt), (I += 1));
                for (; S < I;) {
                  var tt = B[S];
                  S += 1;
                  var fe = ut[tt];
                  if (!(fe >= 3)) {
                    var ge = Math.floor(tt / p),
                      Ge = tt - ge * p,
                      St = [];
                    (Ge > 0 && St.push(tt - 1),
                      Ge + 1 < p && St.push(tt + 1),
                      ge > 0 && St.push(tt - p),
                      ge + 1 < f && St.push(tt + p),
                      St.forEach(function (g) {
                        ut[g] <= fe + 1 ||
                          ((ut[g] = fe + 1), (B[I] = g), (I += 1));
                      }));
                  }
                }
                for (var Rt = 0; Rt < T; Rt += 1) {
                  var ve = ut[Rt],
                    V = Rt * 4;
                  if (!(ve < 1 || ve > 3 || m[V + 3] < 16)) {
                    var Ra = Math.max(
                        Math.abs(h[V] - N[0]),
                        Math.abs(h[V + 1] - N[1]),
                        Math.abs(h[V + 2] - N[2]),
                      ),
                      Ba = Math.max(0, Math.min(1, Ra / 72)),
                      Pa = Math.pow(Ba, 1 / ve),
                      ja = m[V + 3] / 255,
                      $ = Math.min(ja, Pa);
                    if (!($ >= 0.995)) {
                      if ($ <= 0.025) {
                        m[V + 3] = 0;
                        continue;
                      }
                      ((m[V] = Math.max(
                        0,
                        Math.min(255, Math.round((m[V] - (1 - $) * dt[0]) / $)),
                      )),
                        (m[V + 1] = Math.max(
                          0,
                          Math.min(
                            255,
                            Math.round((m[V + 1] - (1 - $) * dt[1]) / $),
                          ),
                        )),
                        (m[V + 2] = Math.max(
                          0,
                          Math.min(
                            255,
                            Math.round((m[V + 2] - (1 - $) * dt[2]) / $),
                          ),
                        )),
                        (m[V + 3] = Math.round($ * 255)));
                    }
                  }
                }
              }
              if (r) {
                for (
                  var Je = function (g, q) {
                      Bt[g] ||
                        m[g * 4 + 3] < 16 ||
                        ((Bt[g] = q), (B[I] = g), (I += 1));
                    },
                    Bt = new Int32Array(T),
                    Pt = 0,
                    ze = 0,
                    Ye = 0,
                    At = 0;
                  At < T;
                  At += 1
                )
                  if (!(Bt[At] || m[At * 4 + 3] < 16)) {
                    ((Pt += 1), (S = 0), (I = 0), Je(At, Pt));
                    for (var he = 0; S < I;) {
                      var Xe = B[S];
                      ((S += 1), (he += 1));
                      for (
                        var jt = Math.floor(Xe / p), be = Xe - jt * p, lt = -1;
                        lt <= 1;
                        lt += 1
                      )
                        for (var pt = -1; pt <= 1; pt += 1)
                          (!lt && !pt) ||
                            jt + lt < 0 ||
                            jt + lt >= f ||
                            be + pt < 0 ||
                            be + pt >= p ||
                            Je((jt + lt) * p + be + pt, Pt);
                    }
                    he > Ye && ((Ye = he), (ze = Pt));
                  }
                for (var kt = 0; kt < T; kt += 1)
                  m[kt * 4 + 3] >= 16 && Bt[kt] !== ze && (m[kt * 4 + 3] = 0);
              }
              (_.putImageData(A, 0, 0), s(C.toDataURL("image/png")));
            } catch {
              s("");
            }
          }
          ((o.onload = function () {
            if (!e) {
              c(o);
              return;
            }
            var l = new window.Image();
            ((l.crossOrigin = "anonymous"),
              (l.decoding = "async"),
              (l.onload = function () {
                c(l);
              }),
              (l.onerror = function () {
                s("");
              }),
              (l.src = Be(e)));
          }),
            (o.onerror = function () {
              s("");
            }),
            (o.src = Be(t)));
        })),
      $t[n]
    );
  }
  function ne(t, e, a) {
    if (!t || !e) return;
    var r = t.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var i = Math.max(r.width, r.height, 96),
      n = a && a.centerInViewport,
      s = r.left + r.width / 2,
      o = r.top + r.height / 2,
      c = n ? window.innerWidth / 2 : s,
      l = n ? window.innerHeight / 2 : o;
    (G && G.remove(), J && J.remove());
    var d = null;
    n &&
      ((d = document.createElement("span")),
      (J = d),
      (d.className = "pesado-cart-companion__spotlight-backdrop"),
      d.setAttribute("aria-hidden", "true"),
      document.body.appendChild(d));
    var u = document.createElement("span");
    ((G = u),
      (u.className =
        "pesado-cart-companion__spotlight-zoom" +
        (n ? " is--viewport-centered" : "")),
      u.setAttribute("aria-hidden", "true"),
      (u.style.left = c + "px"),
      (u.style.top = l + "px"),
      (u.style.width = i + "px"),
      (u.style.height = i + "px"),
      n &&
        (u.style.setProperty("--pcc-spotlight-origin-x", s - c + "px"),
        u.style.setProperty("--pcc-spotlight-origin-y", o - l + "px")),
      (u.innerHTML = '<img src="' + w(e) + '" alt="">'));
    var b = window.setTimeout(y, 2200);
    function y(x) {
      (x && x.target !== u) ||
        (window.clearTimeout(b),
        u.removeEventListener("animationend", y),
        u.remove(),
        G === u && (G = null),
        d && d.remove(),
        J === d && (J = null));
    }
    (u.addEventListener("animationend", y), document.body.appendChild(u));
  }
  function Pe(t, e) {
    !t || !e || ne(t.querySelector(".pesado-cart-companion__image img"), e);
  }
  function je(t) {
    if (!(
      !t || window.matchMedia("(prefers-reduced-motion: reduce)").matches
    )) {
      var e = t.querySelector(".pesado-cart-companion__image img");
      if (e) {
        var a = t.getAttribute("data-pcc-cutout") || "",
          r = t.getAttribute("data-pcc-current-image") || e.currentSrc || e.src,
          i = t.getAttribute("data-pcc-spotlight-mask-image") || "",
          n = (ft += 1);
        if (!r || r === a) {
          Pe(t, a || r);
          return;
        }
        re(r, i).then(function (s) {
          n !== ft ||
            !t.isConnected ||
            t.getAttribute("data-pcc-current-image") !== r ||
            Pe(t, s || a || r);
        });
      }
    }
  }
  function Aa(t) {
    if (!(
      !t || window.matchMedia("(prefers-reduced-motion: reduce)").matches
    )) {
      var e = t.trigger,
        a = e && (e.matches("img") ? e : e.querySelector("img")),
        r = t.currentImage || (a && (a.currentSrc || a.src)) || "",
        i = t.cutout || "",
        n = t.maskImage || "";
      if (!(!e || !a || !r)) {
        var s = (ft += 1);
        if (r === i) {
          ne(a, i, { centerInViewport: !0 });
          return;
        }
        re(r, n, {
          keepLargestComponent: t.keepLargestComponent !== !1,
          cleanNeutralBackdrop: !0,
        }).then(function (o) {
          if (!(
            s !== ft ||
            !e.isConnected ||
            e.getAttribute("data-pcg-current-image") !== r
          )) {
            var c = o || i;
            c && ne(a, c, { centerInViewport: !0 });
          }
        });
      }
    }
  }
  document.addEventListener("pesado:product-spotlight", function (t) {
    Aa((t && t.detail) || {});
  });
  function ka(t, e, a) {
    if (
      (Re(),
      !(
        !ae(t).eligible ||
        !e.length ||
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ))
    ) {
      var r = e[0],
        i = [
          Math.round(Number(t.total_price || 0)),
          r.productId || r.handle,
          r.pesadoTargetTier,
        ].join("|");
      try {
        if (sessionStorage.getItem("pesado_nudge_" + i) === "1") return;
      } catch {}
      Dt = setTimeout(function () {
        if (!(!k || k.hidden || k.getAttribute("data-render-key") !== a)) {
          var n = k.querySelector("[data-pcc-product]");
          if (n) {
            n.classList.add("is--reward-nudge");
            var s = n.querySelector("[data-pcc-nudge]");
            (s && (s.hidden = !1), je(n));
            try {
              sessionStorage.setItem("pesado_nudge_" + i, "1");
            } catch {}
            ((Ft = i),
              gt("recommendation_nudge_view", {
                product_id: r.productId,
                product_handle: r.handle,
                rank: r.pesadoRank,
                reason: r.pesadoReason,
                target_tier: r.pesadoTargetTier,
                gap_before: r.pesadoGapBefore,
              }));
          }
        }
      }, 5e3);
    }
  }
  function ie() {
    return (
      (k && document.documentElement.contains(k)) ||
        ((k = document.createElement("aside")),
        (k.className = "pesado-cart-companion"),
        k.setAttribute("data-pesado-cart-companion", ""),
        k.setAttribute("aria-label", "Compatible additions"),
        (k.hidden = !0),
        k.addEventListener("click", Ea),
        k.addEventListener("change", Ta),
        k.addEventListener("keydown", La),
        k.addEventListener("wheel", wa, { passive: !1 }),
        ["pointerdown", "scroll", "keydown"].forEach(function (t) {
          k.addEventListener(t, Re, { passive: !0 });
        }),
        document.body.appendChild(k)),
      k
    );
  }
  function He(t) {
    var e = document.getElementById("t4s-mini_cart");
    if (!(!t && e && e.getAttribute("aria-hidden") === "false" && !rt)) {
      ((rt = !0),
        (mt += 1),
        document.documentElement.classList.add("pesado-cart-preparing"),
        clearTimeout(W));
      var a = mt;
      W = setTimeout(function () {
        rt && a === mt && Nt();
      }, 600);
    }
  }
  function De(t) {
    ((Ht += 1), (Z += 1), (D = null), (P += 1), clearTimeout(W), (W = null));
    var e = document.getElementById("t4s-mini_cart");
    t && (!e || e.getAttribute("aria-hidden") !== "false") && He();
  }
  function oe(t, e) {
    if (((Z = Math.max(0, Z - 1)), !Z)) {
      if (t && !e) {
        var a = document.getElementById("t4s-mini_cart");
        (!a || a.getAttribute("aria-hidden") !== "false") && Nt();
      }
      O(0);
    }
  }
  function Nt() {
    (clearTimeout(W),
      (W = null),
      (rt = !1),
      document.documentElement.classList.remove("pesado-cart-preparing"));
  }
  function ce(t, e) {
    if (
      !t ||
      t.getAttribute("aria-hidden") !== "false" ||
      t.classList.contains("is--contentUpdate")
    )
      return !1;
    var a = t.querySelector("[data-cart-items]");
    if (!a) return !1;
    if (!e || typeof e.item_count != "number") return !0;
    var r = e.items || [],
      i = Array.from(a.querySelectorAll("[data-cart-item]"));
    if (i.length !== r.length) return !1;
    var n = r
        .map(function (o) {
          return (
            String(o.key || o.variant_id || o.id || "") +
            ":" +
            Number(o.quantity || 0)
          );
        })
        .sort(),
      s = i
        .map(function (o) {
          var c = o.querySelector("[data-quantity-value]"),
            l = o.querySelector("[data-cart-remove]"),
            d =
              (c && c.getAttribute("data-id")) ||
              (l && l.getAttribute("data-id")) ||
              "",
            u = c
              ? Number(c.value || c.getAttribute("data-current-qty") || 0)
              : 0;
          return String(d) + ":" + u;
        })
        .sort();
    return n.join("|") !== s.join("|")
      ? !1
      : (t.getAttribute("data-ccount") !== String(e.item_count) &&
          t.setAttribute("data-ccount", String(e.item_count)),
        xe(e),
        !0);
  }
  function Fe(t) {
    var e = t && t.querySelector("[data-cart-items]"),
      a = t && t.querySelector(".t4s-cart__totalPrice");
    return [
      t ? t.getAttribute("data-ccount") : "",
      t ? t.className : "",
      e ? e.querySelectorAll("[data-cart-item]").length : -1,
      e ? e.innerHTML.length : -1,
      a ? a.textContent.trim() : "",
    ].join("|");
  }
  function yt(t, e) {
    if (!(!rt || Z || e !== P)) {
      var a = document.getElementById("t4s-mini_cart");
      if (ce(a, t)) {
        var r = mt,
          i = Fe(a);
        (clearTimeout(W),
          (W = setTimeout(function () {
            !rt ||
              Z ||
              r !== mt ||
              e !== P ||
              a !== document.getElementById("t4s-mini_cart") ||
              !ce(a, t) ||
              i !== Fe(a) ||
              Nt();
          }, 80)));
      }
    }
  }
  function qt() {
    return window.matchMedia("(max-width: 979px)").matches;
  }
  function $e(t) {
    if (qt()) {
      var e = document.querySelector("#t4s-mini_cart .t4s-drawer__scroll"),
        a = e && e.querySelector("[data-cart-items]");
      a && a.nextElementSibling !== t
        ? a.insertAdjacentElement("afterend", t)
        : e && !a && t.parentNode !== e && e.appendChild(t);
    } else t.parentNode !== document.body && document.body.appendChild(t);
  }
  function xa(t) {
    return t.shortTitle || ra[t.recommendationId] || t.title || "";
  }
  function groupConfiguredPortafilters(products, context) {
    if (!context || !context.modelId) return products;
    var config = window.PesadoCompatibilityManagerConfig?.configuration,
      model = config?.brands?.find(brand => brand.id === context.brandId)?.models?.find(item => item.id === context.modelId),
      result = products.slice();
    for (const familyId of model?.configurationFamilyIds || []) {
      const family = config.productFamilies?.find(item => item.id === familyId && item.enabled !== false);
      const ids = new Set((family?.members || []).filter(member => member.enabled !== false).map(member => member.productId));
      const members = result.filter(product => ids.has(product.recommendationId));
      if (!members.length) continue;
      const representative = members.find(product => /^hybrid-/.test(product.handle)) || members[0];
      const index = result.findIndex(product => ids.has(product.recommendationId));
      result = result.filter(product => !ids.has(product.recommendationId));
      result.splice(index, 0, Object.assign({}, representative, { shortTitle: "Portafilters", category: "portafilter" }));
    }
    return result;
  }
  function Ca(t, e, context) {
    var a = t.variants.filter(function (f) {
      return f.available;
    });
    if (!a.length) return "";
    var r = t.category === "portafilter",
      i = a[0],
      n = i.image || t.image,
      s = t.cutout || "",
      o = s || n,
      c = xa(t),
      l = o ? '<img src="' + w(o) + '" alt="" loading="lazy">' : "",
      d = "";
    if (!r && a.length === 1)
      d =
        '<div class="pesado-cart-companion__option pesado-cart-companion__option--fixed"><span>Compatible variant</span><strong data-pcc-fixed-variant>' +
        w(
          String(i.title || "").toLowerCase() === "default title" ? c : i.title,
        ) +
        "</strong></div>";
    else if (!r && a.length > 1) {
      var u = "pcc-variant-list-" + t.productId;
      d =
        '<div class="pesado-cart-companion__option"><span>Choose an option</span><select data-pcc-variant aria-label="Choose an option">' +
        a
          .map(function (f) {
            return (
              '<option value="' +
              f.id +
              '" data-price="' +
              f.price +
              '" data-image="' +
              w(f.image || t.image) +
              '">' +
              w(f.title) +
              "</option>"
            );
          })
          .join("") +
        '</select><div class="pesado-cart-companion__mobile-variant" data-pcc-mobile-variant><button type="button" class="pesado-cart-companion__mobile-variant-trigger" data-pcc-mobile-variant-trigger aria-haspopup="listbox" aria-expanded="false" aria-controls="' +
        u +
        '"><span data-pcc-mobile-variant-label>' +
        w(i.title) +
        '</span><i aria-hidden="true"></i></button><div id="' +
        u +
        '" class="pesado-cart-companion__mobile-variant-list" data-pcc-mobile-variant-list role="listbox" hidden>' +
        a
          .map(function (f, C) {
            return (
              '<button type="button" role="option" data-pcc-mobile-variant-option data-value="' +
              f.id +
              '" aria-selected="' +
              (C === 0 ? "true" : "false") +
              '">' +
              w(f.title) +
              "</button>"
            );
          })
          .join("") +
        "</div></div></div>";
    }
    var b =
        '<div class="pesado-cart-companion__option-slot">' +
        (d ||
          '<span class="pesado-cart-companion__option-placeholder" aria-hidden="true">&nbsp;</span>') +
        "</div>",
      y = r
        ? '<button type="button" data-pcc-configure-portafilter>Choose options</button>'
        : '<button type="button" data-pcc-add data-variant-id="' +
          i.id +
          '">Add to basket</button>',
      x = _a(t, e),
      p = t.pesadoCompatibilityPriority
        ? '<span class="pesado-cart-companion__fit-priority">Required for your HE basket</span>'
        : "";
    return (
      '<article class="pesado-cart-companion__card" data-pcc-product data-product-id="' +
      t.productId +
      '" data-product-handle="' +
      w(t.handle) +
      '" data-recommendation-id="' +
      w(t.recommendationId) +
      '" data-pcc-portafilter="' +
      (r ? "true" : "false") +
      '" data-pcc-cutout="' +
      w(s) +
      '" data-pcc-current-image="' +
      w(o) +
      '" data-pcc-rank="' +
      (t.pesadoRank || "") +
      '" data-pcc-reason="' +
      w(t.pesadoReason || "") +
      '" data-pcc-target="' +
      (t.pesadoTargetTier || "") +
      '" data-pcc-gap="' +
      (t.pesadoGapBefore || "") +
      '"><button type="button" class="pesado-cart-companion__image" data-pcc-image-add aria-label="View ' +
      w(c) +
      ' larger">' +
      l +
      '</button><div class="pesado-cart-companion__details"><h3>' +
      w(c) +
      "</h3><strong data-pcc-price>" +
      w(st(i.price, e)) +
      "</strong>" +
      (window.PesadoFitRequirements ? window.PesadoFitRequirements.markup(context, t) : "") +
      p +
      b +
      '<span class="pesado-cart-companion__nudge" data-pcc-nudge hidden>' +
      w(x) +
      "</span>" +
      y +
      '<span class="pesado-cart-companion__status" data-pcc-status role="status" aria-live="polite"></span></div></article>'
    );
  }
  function Ot(t, e, a, r, i) {
    if (r === P) {
      var n = ie();
      $e(n);
      var s = (e && e.currency) || vt() || "AUD",
        o = Ve(e, a),
        c = o
          ? '<aside class="pesado-cart-companion__fit-notice"><strong>HE basket fit requirement</strong><span>Pesado HE baskets are not compatible with the original Breville portafilter. Use the matching Pesado Breville ' +
            o +
            "mm portafilter.</span></aside>"
          : "",
        l = t
          .map(function (C) {
            return Ca(C, s, a);
          })
          .filter(Boolean)
          .join(""),
        d = zt() && F.showCompleteKit !== !1 && a.screenCompatibility !== !1,
        u = d ? Ue(i || [], e, a) : null,
        b =
          u && !u.missing.length && l
            ? '<div class="pesado-cart-companion__upgrade-intro"><small>Optional upgrades</small><strong>Upgrade your setup</strong></div>'
            : "",
        y = d ? ha(i || [], e, a, s) : "";
      if (
        !et ||
        (!l &&
          !y &&
          (!a.products || !a.products.length || a.suppressRecommendations))
      ) {
        ((n.hidden = !0),
          document.documentElement.classList.remove(
            "pesado-cart-has-companion",
          ),
          et && yt(e, r));
        return;
      }
      var x = qt(),
        p =
          String(a.label || "")
            .replace(/^Compatible with(?: your)?\s+/i, "")
            .trim() || "Selected setup",
        f = [a.label, s, o, y, l, x, ot].join("|");
      if (
        ((n.hidden = !1),
        n.classList.toggle("is--mobile-collapsed", x && !ot),
        document.documentElement.classList.add("pesado-cart-has-companion"),
        n.getAttribute("data-render-key") === f)
      ) {
        yt(e, r);
        return;
      }
      ((n.innerHTML =
        '<header class="pesado-cart-companion__header"><div><small class="pesado-cart-companion__eyebrow">Compatible additions</small><h2>' +
        w(
          a.universalOnly
            ? "Accessories for your workflow"
            : a.family
              ? "Complete your setup"
              : F.fallbackTitle || "Popular additions",
        ) +
        '</h2><p class="pesado-cart-companion__fit-context" aria-label="' +
        w(a.label) +
        '"><i aria-hidden="true">&#10003;</i><span><small>' +
        (a.universalOnly ? "From our universal range" : "Compatible with") +
        "</small><strong>" +
        w(p) +
        '</strong></span></p></div><button type="button" class="pesado-cart-companion__toggle" data-pcc-toggle aria-expanded="' +
        (ot ? "true" : "false") +
        '"><span>' +
        (ot ? "Hide" : "View") +
        '</span><i aria-hidden="true"></i></button></header>' +
        c +
        '<div class="pesado-cart-companion__cards">' +
        b +
        l +
        y +
        (!l && !y
          ? '<p class="pesado-cart-companion__empty">No additional items are available for this setup right now.</p>'
          : "") +
        "</div>"),
        n.setAttribute("data-render-key", f),
        gt("recommendation_panel_view", {
          context: a.label,
          source_handle: a.sourceHandle,
          product_ids: t
            .map(function (C) {
              return C.productId;
            })
            .join(","),
          target_tier: t[0] && t[0].pesadoTargetTier,
          gap_before: t[0] && t[0].pesadoGapBefore,
        }),
        ka(e, t, f),
        yt(e, r));
    }
  }
  function se(t, fitReady) {
    var e = ++P,
      a = ie();
    if (($e(a), !et || F.enabled === !1)) {
      ((a.hidden = !0),
        document.documentElement.classList.remove("pesado-cart-has-companion"));
      return;
    }
    if (!t) {
      ((a.hidden = !0),
        document.documentElement.classList.remove("pesado-cart-has-companion"),
        yt(null, e));
      return;
    }
    if (!ce(document.getElementById("t4s-mini_cart"), t)) {
      ((D = null), O(150));
      return;
    }
    if (!t.items || !t.items.length) {
      ((a.hidden = !0),
        document.documentElement.classList.remove("pesado-cart-has-companion"),
        yt(t, e));
      return;
    }
    var fit = companionFitApi();
    if (companionFitRequired() && (!fit || !fitReady)) {
      a.hidden = true;
      document.documentElement.classList.remove('pesado-cart-has-companion');
      yt(t, e);
      if (fit) fit.ready().then(function () { if (e === P) se(t, true); }).catch(function () { if (e === P) yt(t, e); });
      return;
    }
    var r = la(t),
      i = v || Et();
    if (fit) {
      var cartFit = fit.evaluate(t);
      if (cartFit.conflicts.length) r = null;
      i = cartFit.conflicts.length ? null : validCompanionMachineContext(i, t) ? i : r;
      if (!i && v) { v = null; Xt(null); }
    }
    if (
      (i
        ? ((!pa(i, t) && !ma(i, t)) ||
            (!i.sourceHandle && r && !i.machineSelection)) &&
          (i = r)
        : (i = r),
      i || (i = te()),
      !i)
    ) {
      Ot([], t, { label: "" }, e, []);
      return;
    }
    if ((i !== v && ((v = i), Xt(v)), i.suppressRecommendations)) {
      Ot([], t, i, e, []);
      return;
    }
    var n = {},
      s = {},
      o = Ne(t);
    (t.items || []).forEach(function (y) {
      ((n[Number(y.product_id)] = !0), y.handle && (s[y.handle] = !0));
    });
    var c = ua(i),
      l = zt() && F.showCompleteKit !== !1 && i.screenCompatibility !== !1,
      d = l ? c : [],
      u = c.filter(function (y) {
        var x = ct(y).category;
        return x === "screen" || x === "basket" || x === "portafilter";
      }),
      b = l ? i.products : u.concat(i.products);
    Promise.all([
      Promise.all(b.map(ee)),
      Promise.all(
        d.map(function (y) {
          return ee(ct(y));
        }),
      ),
    ])
      .then(function (y) {
        if (e === P) {
          var x = filterCompanionFitProducts(y[0], t),
            p = o
              ? filterCompanionFitProducts(y[1], t).filter(function (A) {
                  return !Ee(A);
                })
              : filterCompanionFitProducts(y[1], t),
            f = {},
            C = {},
            _ = x.filter(function (A) {
              if (
                !A ||
                !A.variants.some(function (L) {
                  return L.available;
                }) ||
                (o && Ee(A))
              )
                return !1;
              var m = Number(A.productId),
                h = A.handle || "";
              return (!m && !h) || (m && f[m]) || (h && C[h]) || n[m] || s[h]
                ? !1
                : (m && (f[m] = !0), h && (C[h] = !0), !0);
            });
          ((_ = ya(groupConfiguredPortafilters(_, i), t, i)), Ot(_, t, i, e, p));
        }
      })
      .catch(function () {
        e === P && Ot([], t, i, e, []);
      });
  }
  function O(t) {
    (clearTimeout(_e),
      (_e = setTimeout(
        function () {
          if ((de(), !!et)) {
            if (Z) {
              O(50);
              return;
            }
            if (D) {
              se(D);
              return;
            }
            Ce()
              .then(function (e) {
                ((D = e), se(e));
              })
              .catch(function (e) {
                e.staleCart ? O(0) : se(null);
              });
          }
        },
        typeof t == "number" ? t : 80,
      )));
  }
  function de() {
    var t = document.getElementById("t4s-mini_cart"),
      e = !!(t && t.getAttribute("aria-hidden") === "false"),
      a = t !== we,
      r = e !== et;
    if (
      ((we = t),
      document.documentElement.classList.toggle("pesado-cart-visible", e),
      !(!a && !r))
    ) {
      if (((et = e), e)) ((D = null), v || (v = Et()), r ? He(!0) : (P += 1));
      else {
        ((P += 1), Nt());
        var i = ie();
        ((i.hidden = !0),
          document.documentElement.classList.remove(
            "pesado-cart-has-companion",
          ));
      }
      document.dispatchEvent(
        new CustomEvent("pesado:cart-state", { detail: { open: e } }),
      );
    }
  }
  function Ia() {
    var t = document.getElementById("t4s-mini_cart");
    !t ||
      t.getAttribute("data-pesado-state-observed") === "1" ||
      !window.MutationObserver ||
      (t.setAttribute("data-pesado-state-observed", "1"),
      new MutationObserver(function (e) {
        var a = e.some(function (r) {
          if (r.target === t) return !0;
          var i = r.target.nodeType === 1 ? r.target : r.target.parentElement;
          return (
            r.type === "childList" &&
            i &&
            !i.closest(".pesado-cart-companion") &&
            (i.matches("[data-cart-items]") ||
              Array.from(r.addedNodes)
                .concat(Array.from(r.removedNodes))
                .some(function (n) {
                  return (
                    n.nodeType === 1 &&
                    (n.matches("[data-cart-items], [data-cart-item]") ||
                      n.querySelector("[data-cart-items], [data-cart-item]"))
                  );
                }))
          );
        });
        a && (de(), O(30));
      }).observe(t, {
        attributes: !0,
        attributeFilter: ["aria-hidden", "class", "data-ccount"],
        childList: !0,
        subtree: !0,
      }));
  }
  function Ut(t, e) {
    if (t) {
      var a = t.querySelector("[data-pcc-mobile-variant-trigger]"),
        r = t.querySelector("[data-pcc-mobile-variant-list]");
      !a ||
        !r ||
        (t.classList.toggle("is-open", e),
        a.setAttribute("aria-expanded", e ? "true" : "false"),
        (r.hidden = !e));
    }
  }
  function ue(t) {
    k &&
      k
        .querySelectorAll("[data-pcc-mobile-variant].is-open")
        .forEach(function (e) {
          e !== t && Ut(e, !1);
        });
  }
  function Ma(t) {
    if (t) {
      var e = t.options[t.selectedIndex],
        a = t.closest("[data-pcc-product]");
      if (!(!a || !e)) {
        var r = a.querySelector("[data-pcc-add]"),
          i = a.querySelector("[data-pcc-price]"),
          n = a.querySelector(".pesado-cart-companion__image img");
        if (
          (r && r.setAttribute("data-variant-id", e.value),
          i &&
            (i.textContent = st(e.getAttribute("data-price"), D && D.currency)),
          n && e.getAttribute("data-image"))
        ) {
          var s = e.getAttribute("data-image"),
            o = Sa(t, e, a);
          ((n.src = s),
            a.setAttribute("data-pcc-current-image", s),
            o
              ? a.setAttribute("data-pcc-spotlight-mask-image", o)
              : a.removeAttribute("data-pcc-spotlight-mask-image"),
            re(s, o));
        }
        var c = a.querySelector("[data-pcc-mobile-variant]");
        if (c) {
          var l = c.querySelector("[data-pcc-mobile-variant-label]");
          (l && (l.textContent = e.textContent),
            c
              .querySelectorAll("[data-pcc-mobile-variant-option]")
              .forEach(function (d) {
                d.setAttribute(
                  "aria-selected",
                  d.getAttribute("data-value") === e.value ? "true" : "false",
                );
              }));
        }
      }
    }
  }
  function Ta(t) {
    var e = t.target.closest("[data-pcc-variant]");
    e && Ma(e);
  }
  function La(t) {
    if (t.key === "Escape") {
      var e = t.target.closest("[data-pcc-mobile-variant]");
      if (!(!e || !e.classList.contains("is-open"))) {
        (t.preventDefault(), Ut(e, !1));
        var a = e.querySelector("[data-pcc-mobile-variant-trigger]");
        a && a.focus();
      }
    }
  }
  function Ea(t) {
    var e = t.target.closest("[data-pcc-mobile-variant-trigger]");
    if (e) {
      t.preventDefault();
      var a = e.closest("[data-pcc-mobile-variant]"),
        r = e.getAttribute("aria-expanded") !== "true";
      if ((ue(a), Ut(a, r), r)) {
        var i = a.querySelector(
          '[data-pcc-mobile-variant-option][aria-selected="true"]',
        );
        i && i.scrollIntoView({ block: "nearest" });
      }
      return;
    }
    var n = t.target.closest("[data-pcc-mobile-variant-option]");
    if (n) {
      t.preventDefault();
      var s = n.closest("[data-pcc-mobile-variant]"),
        o = n.closest("[data-pcc-product]"),
        c = o && o.querySelector("[data-pcc-variant]");
      if (!s || !c) return;
      ((c.value = n.getAttribute("data-value")),
        c.dispatchEvent(new Event("change", { bubbles: !0 })),
        Ut(s, !1));
      var l = s.querySelector("[data-pcc-mobile-variant-trigger]");
      l && l.focus({ preventScroll: !0 });
      return;
    }
    ue();
    var d = t.target.closest("[data-pcc-toggle]");
    if (d) {
      ((ot = !ot), O(0));
      return;
    }
    var u = t.target.closest("[data-pcc-configure-portafilter]");
    if (u) {
      t.preventDefault();
      var b = u.closest("[data-pcc-product]");
      if (!b) return;
      var y = qt(),
        x = {
          recommendationId: b.getAttribute("data-recommendation-id"),
          handle: b.getAttribute("data-product-handle"),
          fitLabel: v && v.label,
          modelName: v && v.modelName,
          modelId: v && v.modelId,
          brandId: v && v.brandId,
          cartMetadata: {
            rank: b.getAttribute("data-pcc-rank"),
            reason: b.getAttribute("data-pcc-reason"),
            targetTier: b.getAttribute("data-pcc-target"),
            gapBefore: b.getAttribute("data-pcc-gap"),
          },
          trigger: y ? null : u,
        },
        p = function () {
          if (window.PesadoPdpPortafilter && window.PesadoPdpPortafilter.open(x)) return;
          if (window.PesadoP2Portafilter && window.PesadoP2Portafilter.open(x)) return;
          if (window.PesadoGemilaiPortafilter && window.PesadoGemilaiPortafilter.open(x)) return;
          // Other pages do not embed the family selector. Open the same exact
          // machine in the guide instead of falling back to an unfiltered PF.
          if (x.brandId && x.modelId) {
            const destination = new URL(ht("pages/compatibility-guide"), window.location.origin);
            destination.searchParams.set("view", "compatibility-p2");
            destination.searchParams.set("pcg_brand", x.brandId);
            destination.searchParams.set("pcg_model", x.modelId);
            destination.searchParams.set("pcg_product", x.recommendationId);
            window.location.assign(destination.href);
            return;
          }
          document.dispatchEvent(
            new CustomEvent("pesado:open-portafilter-configurator", {
              detail: x,
            }),
          );
        },
        f = y && document.getElementById("t4s-mini_cart"),
        C = f && f.querySelector(".t4s-drawer__close");
      if (!f || f.getAttribute("aria-hidden") !== "false" || !C) {
        p();
        return;
      }
      C.click();
      var _ = 0,
        A = function () {
          if (f.getAttribute("aria-hidden") === "true" || _ >= 15) {
            p();
            return;
          }
          ((_ += 1), window.setTimeout(A, 40));
        };
      A();
      return;
    }
    var m = t.target.closest("[data-pcc-add-kit]");
    if (m) {
      t.preventDefault();
      var h = String(m.getAttribute("data-variant-ids") || "")
        .split(",")
        .map(Number)
        .filter(Boolean);
      if (!h.length || m.disabled) return;
      var L = m.parentNode.querySelector("[data-pcc-kit-status]"),
        Y = {
          machine: v && v.label,
          parentProduct: v && v.sourceHandle,
          reason: "complete_kit",
        };
      ((m.disabled = !0),
        m.classList.add("is--loading"),
        L && (L.textContent = "Adding\u2026"),
        fitCheckedCompanionAdd(ht("cart/add.js"), {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: h.map(function (E, _t) {
              return {
                id: E,
                quantity: 1,
                properties: Ae(
                  "compatible_additions",
                  Object.assign({}, Y, { rank: _t + 1 }),
                ),
              };
            }),
          }),
        })
          .then(function (E) {
            if (!E.ok) throw new Error("Unable to add complete kit");
            return E.json();
          })
          .then(function () {
            (L && (L.textContent = "Complete kit added"),
              Wt(),
              document.dispatchEvent(new CustomEvent("cart:refresh:opend")),
              setTimeout(Mt, 80));
          })
          .catch(function (error) {
            ((m.disabled = !1),
              m.classList.remove("is--loading"),
              L &&
                (L.textContent = error.name === 'CartFitConflict' ? error.message : "Could not add the complete kit. Try again."));
            if (error.name === 'CartFitConflict') { D = null; O(0); }
          }));
      return;
    }
    var T = t.target.closest("[data-pcc-image-add]");
    if (T) {
      t.preventDefault();
      var R = T.closest("[data-pcc-product]");
      if (qt()) {
        je(R);
        return;
      }
      var N = R && R.querySelector("[data-pcc-configure-portafilter]");
      if (N) {
        N.click();
        return;
      }
      var dt = R && R.querySelector("[data-pcc-add]");
      dt && dt.click();
      return;
    }
    var j = t.target.closest("[data-pcc-add]");
    if (j) {
      t.preventDefault();
      var B = Number(j.getAttribute("data-variant-id"));
      if (!(!B || j.disabled)) {
        var S = j.closest("[data-pcc-product]"),
          I = S && S.querySelector("[data-pcc-status]"),
          U = {
            machine: v && v.label,
            parentProduct: v && v.sourceHandle,
            rank: S && S.getAttribute("data-pcc-rank"),
            reason: S && S.getAttribute("data-pcc-reason"),
            targetTier: S && S.getAttribute("data-pcc-target"),
            gapBefore: S && S.getAttribute("data-pcc-gap"),
          },
          X = S && S.getAttribute("data-product-id"),
          Q = S && S.getAttribute("data-product-handle");
        (gt("recommendation_add_click", {
          product_id: X,
          product_handle: Q,
          variant_id: B,
          rank: U.rank,
          reason: U.reason,
          target_tier: U.targetTier,
          gap_before: U.gapBefore,
          nudge_active: !!Ft,
        }),
          (j.disabled = !0),
          j.classList.add("is--loading"),
          I && (I.textContent = "Adding\u2026"),
          fitCheckedCompanionAdd(ht("cart/add.js"), {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              items: [
                {
                  id: B,
                  quantity: 1,
                  properties: Ae("compatible_additions", U),
                },
              ],
            }),
          })
            .then(function (E) {
              if (!E.ok) throw new Error("Unable to add product");
              return E.json();
            })
            .then(function () {
              (I && (I.textContent = "Added"),
                Wt(),
                gt("recommendation_add_success", {
                  product_id: X,
                  product_handle: Q,
                  variant_id: B,
                  rank: U.rank,
                  reason: U.reason,
                  target_tier: U.targetTier,
                  gap_before: U.gapBefore,
                }),
                document.dispatchEvent(new CustomEvent("cart:refresh:opend")),
                setTimeout(Mt, 80));
            })
            .catch(function (error) {
              ((j.disabled = !1),
                j.classList.remove("is--loading"),
                I && (I.textContent = error.name === 'CartFitConflict' ? error.message : "Could not add. Try again."));
              if (error.name === 'CartFitConflict') { D = null; O(0); }
            }));
      }
    }
  }
  function Na() {
    Se ||
      ((Se = !0),
      document.addEventListener("pesado:cart-recommendations", function (t) {
        qe(t.detail);
      }),
      document.addEventListener("pesado:cart-recommendations:clear", Oe),
      document.addEventListener('pesado:cart-fit-ready', function () { O(0); }),
      document.addEventListener("click", function (t) {
        k && !k.contains(t.target) && ue();
      }),
      window.addEventListener("resize", function () {
        O(100);
      }),
      (window.PesadoCartCompanion = {
        setContext: qe,
        clearContext: Oe,
        open: function () {
          document.dispatchEvent(new CustomEvent("cart:refresh:opend"));
        },
      }));
  }
  var le = "pesado_cart_reservation_expiry",
    Ke = null;
  function qa(t) {
    var e = Math.max(0, Math.floor(t / 1e3)),
      a = Math.floor(e / 60),
      r = e % 60;
    return a + ":" + (r < 10 ? "0" : "") + r;
  }
  function pe() {
    var t = document.querySelector("[data-cart-timer]");
    if (t) {
      var e = parseInt(t.getAttribute("data-cart-item-count"), 10) || 0,
        a = t.querySelector("[data-timer-countdown]");
      if (e === 0) {
        try {
          localStorage.removeItem(le);
        } catch {}
        t.classList.add("t4s-d-none");
        return;
      }
      var r = null;
      try {
        r = parseInt(localStorage.getItem(le), 10);
      } catch {}
      var i = parseFloat(t.getAttribute("data-timer-minutes")) || 10;
      if (!r || isNaN(r) || r <= Date.now()) {
        r = Date.now() + i * 60 * 1e3;
        try {
          localStorage.setItem(le, r);
        } catch {}
      }
      t.classList.remove("t4s-d-none");
      var n = r - Date.now();
      n <= 0
        ? (t.classList.add("is--expired"), a && (a.textContent = "0:00"))
        : (t.classList.remove("is--expired"), a && (a.textContent = qa(n)));
    }
  }
  function Oa() {
    (pe(), !Ke && (Ke = setInterval(pe, 1e3)));
  }
  function Ua() {
    document.addEventListener("change", function (t) {
      var e = t.target.closest("[data-upsell-variant-select]");
      if (e) {
        var a = e.closest("[data-upsell-item]");
        if (a) {
          var r = e.options[e.selectedIndex],
            i = r.getAttribute("data-variant-id"),
            n = r.getAttribute("data-variant-price"),
            s = a.querySelector("[data-upsell-add]");
          s && i && s.setAttribute("data-variant-id", i);
          var o = a.querySelector("[data-upsell-price]");
          if (
            o &&
            n &&
            window.Shopify &&
            typeof Shopify.formatMoney == "function"
          ) {
            var c =
              (window.T4Sconfigs && T4Sconfigs.moneyFormat) || "${{amount}}";
            o.innerHTML = Shopify.formatMoney(n, c);
          }
        }
      }
    });
  }
  var me = null;
  function Va() {
    var t = document.querySelector("[data-cart-announce]");
    if (!(!t || t.getAttribute("data-announce-bound") === "1")) {
      t.setAttribute("data-announce-bound", "1");
      var e = t.querySelectorAll("[data-announce-item]");
      if (!(e.length < 2)) {
        me && clearInterval(me);
        var a = 0;
        me = setInterval(function () {
          (e[a].classList.remove("is--active"),
            (a = (a + 1) % e.length),
            e[a].classList.add("is--active"));
        }, 4e3);
      }
    }
  }
  function Vt() {
    (It(), sa(), Va(), Oa(), Ia(), de(), O(80));
  }
  function refreshCartMarket() {
    Ht += 1;
    D = null;
    P += 1;
    Tt = {};
    Mt();
    Vt();
  }
  function We() {
    if (
      (document.addEventListener(
        "pesado:compatibility-data-ready",
        function () {
          ((v = Lt(window.PesadoCartRecommendationContext) || Et()),
            Qt(v || te()),
            O(0));
        },
      ),
      v || (v = Et()),
      Qt(v || te()),
      Wt(),
      Vt(),
      Ua(),
      Mt(),
      document.body.addEventListener("currency:update", refreshCartMarket),
      window.addEventListener("pageshow", function (event) { if (event.persisted) refreshCartMarket(); }),
      window.MutationObserver)
    ) {
      var t = null,
        e = new MutationObserver(function (a) {
          var r = a.some(function (i) {
            return Array.from(i.addedNodes).some(function (n) {
              return (
                n.nodeType === 1 &&
                (n.id === "t4s-mini_cart" || n.querySelector("#t4s-mini_cart"))
              );
            });
          });
          r && (clearTimeout(t), (t = setTimeout(Vt, 0)));
        });
      e.observe(document.body, { childList: !0, subtree: !0 });
    }
    [300, 800, 1500, 3e3].forEach(function (a) {
      setTimeout(Vt, a);
    });
  }
  (Na(),
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", We)
      : We(),
    (window.T4SUpdateShipBar = It));
})();
